import { render } from "./TheFooter.vue?vue&type=template&id=41bee61a"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=41bee61a&lang=css"

import exportComponent from "C:\\www\\webdesign - zelena\\vue\\dotacezelena-cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__